/**
 * Stable CSS class names for E2E — RuleServiceV2 Rule tab.
 */
export const RT = {
    root: 'rule-tab',
    createButton: 'rule-tab-input--button-create',
    gridSection: 'rule-tab__grid-section',
    modalSection: 'rule-tab__modal-section',
} as const;

export const rtCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

